export default class CompanyAndAdminAccountDto {
    constructor(companyDto, adminAccountDto) {
        this.company = companyDto;
        this.administrorAccount = adminAccountDto;
    }
}